import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Card, CardContent, Typography } from "@material-ui/core";
import StarIcon from '@material-ui/icons/Star';

const useStyles = makeStyles((theme)=>({
  root: {
    width: 180,
    minWidth: 100,
    margin: 8
  },
  title: {
    fontSize: 14,
  },
}));

const CategoryStat = ({title, score }) => {
  const classes = useStyles();
  return (
    <Card className={classes.root} variant="outlined">
      <CardContent>
        <Typography className={classes.root.title} color="textSecondary">
          {title}
        </Typography>
        <Typography inline="true" variant="h5" align="right">
          {isNaN(score) ? 0 : parseFloat(score).toFixed(2)}
          <span>
              <StarIcon htmlColor="gold" fontSize="small"/>
          </span>
        </Typography>
      </CardContent>
    </Card>
  );
};
export default CategoryStat;
